import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../../shared/components/UIElements/Avatar';
import Card from '../../shared/components/UIElements/Card';

import './ClassSnippet.css';

const ClassSnippet = props => {
  return (
    <li className="class-item">
      <Card className="class-item__content"> 
          <div className="class-item__image">
            <Avatar image={props.image} alt={props.title} />
          </div>
          <div className="class-item__info">
            <h3> <Link to={`/classes/${props.id}`} title={props.uri}>{props.title}</Link></h3> 
            <h5>{props.description}</h5>
            <h4><Link to={`/datasets/${props.datasetid}`}>{props.dataset}</Link></h4>
           
            <h4> Entities: {props.numOfEntities} &nbsp;&nbsp; Recommendations: {props.numOfRecommendations} </h4>
          </div>  
      </Card>
     
    </li>
  );
};

export default ClassSnippet;